// eslint-disable-next-line no-shadow
export var PAYMENT_FORM_MODE;
(function (PAYMENT_FORM_MODE) {
    PAYMENT_FORM_MODE["EDIT_CREDIT_CARD"] = "EDIT_CREDIT_CARD";
    PAYMENT_FORM_MODE["REMOTE_PURCHASES_CREDIT_CARD"] = "REMOTE_PURCHASES_CREDIT_CARD";
    PAYMENT_FORM_MODE["AUTH_HD_WALLET_CREDIT_CARD"] = "AUTH_HD_WALLET_CREDIT_CARD";
    PAYMENT_FORM_MODE["REMOTE_PURCHASES_PRO_HOUSE_ACCOUNT"] = "REMOTE_PURCHASES_PRO_HOUSE_ACCOUNT";
})(PAYMENT_FORM_MODE || (PAYMENT_FORM_MODE = {}));
export var THDPassBusEvents;
(function (THDPassBusEvents) {
    THDPassBusEvents["UNABLE_TO_GET_CARD_DATA"] = "UNABLE_TO_GET_CARD_DATA";
    THDPassBusEvents["ENROLLED"] = "ENROLLED";
    THDPassBusEvents["CANCELLED"] = "CANCELLED";
})(THDPassBusEvents || (THDPassBusEvents = {}));
